import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "parametersContainer"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "frequencySetting"
};
const _hoisted_4 = {
  class: "subtitle"
};
const _hoisted_5 = {
  class: "activationSetting"
};
const _hoisted_6 = {
  class: "subtitle"
};
const _hoisted_7 = {
  id: "scrollable"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "group"
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "group"
};
const _hoisted_12 = {
  class: "group"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_select = _resolveComponent("w-select");
  const _component_notification_parameters_type_notification = _resolveComponent("notification-parameters-type-notification");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("notification.parameters")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("notification.frequence.label")), 1), _createVNode(_component_w_select, {
    options: _ctx.frequencyOptions,
    "value-key": 'id',
    value: _ctx.frequencySelected,
    onChange: _ctx.changeFrequency
  }, null, 8, ["options", "value", "onChange"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("notification.activate")), 1), _createElementVNode("div", _hoisted_7, [_ctx.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("notification.administrator.title")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeNotificationAdmin, typeNotification => {
    return _openBlock(), _createBlock(_component_notification_parameters_type_notification, {
      key: typeNotification.id,
      "key-label": _ctx.getTypeNotificicationKey(typeNotification.typeNotification),
      active: typeNotification.activate,
      type: typeNotification.typeNotification,
      class: "notification"
    }, null, 8, ["key-label", "active", "type"]);
  }), 128))])) : _createCommentVNode("", true), _ctx.isAuthor ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("notification.author.title")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeNotificationAuthor, typeNotification => {
    return _openBlock(), _createBlock(_component_notification_parameters_type_notification, {
      key: typeNotification.id,
      "key-label": _ctx.getTypeNotificicationKey(typeNotification.typeNotification),
      active: typeNotification.activate,
      type: typeNotification.typeNotification,
      class: "notification"
    }, null, 8, ["key-label", "active", "type"]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("notification.user.title")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeNotificationUser, typeNotification => {
    return _openBlock(), _createBlock(_component_notification_parameters_type_notification, {
      key: typeNotification.id,
      "key-label": _ctx.getTypeNotificicationKey(typeNotification.typeNotification),
      active: typeNotification.activate,
      type: typeNotification.typeNotification,
      class: "notification"
    }, null, 8, ["key-label", "active", "type"]);
  }), 128))])]), _cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "footer"
  }, null, -1))]);
}